// extracted by mini-css-extract-plugin
export default {"header":"styles_header__icj+i","title":"styles_title__hl9ux","btn":"styles_btn__3L8hA","btn__changed":"styles_btn__changed__Nj9yc","btn__disabled":"styles_btn__disabled__TwSl8"};